import React from 'react';
import auth from './auth';
import config from './Config/Config';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import Dropdown from 'react-bootstrap/Dropdown';
import Container from 'react-bootstrap/Container';
import { Prompt } from 'react-router-dom';
import PersonalDetailsIcon from '../Resources/Home_Icons/PersonalDetailsIcon.png';
import PreferencesIcon from '../Resources/Home_Icons/PreferencesIcon.png';
import RewardsIcon from '../Resources/Home_Icons/RewardsIcon.png';
import ReferIcon from '../Resources/Home_Icons/ReferIcon.png';
import AppIcon from '../Resources/Home_Icons/AppIcon.png';
import CardIcon from '../Resources/Home_Icons/CardIcon.png';
import { useAlert } from 'react-alert';
import { Setting2 } from './Home/Children/Setting2';

export const Home = props =>{
  const [firstName, setFirstName] = React.useState('');
  
  const [savePreferences, setSavePreferences] = React.useState(false);
  const [saveDetails, setSaveDetails] = React.useState(false);

  //Modal
  const [showModal, setShowModal] = React.useState(false);
  const [modalSetting, setModalSetting] = React.useState(1);

  //Sets free memberships
  const [freeMembership, setFreeMembership] = React.useState(false);

  React.useEffect(() => {
    setFreeMembership(config.getFreeMembershipConfig());

    if('parentIFrame' in window){
      window.parentIFrame.scrollTo(0, 0);
    }

    const  headers =  {
      token: sessionStorage.getItem('token'),
      memberNumber: sessionStorage.getItem('memberNumber')
    }

    fetch(localStorage.getItem('server') + 'member', {
      method: 'GET',
      headers
    })
    .then(function(resp){
      return resp.json();
    })
    .then(function(data){
      if(data.status === 401){
        alert.show(
          <span ref={sessionRef}>
              Your session has expired. Please login to continue.
          </span>
          , {
              title: "Session Expired"
      });
      } else if(data.status === 429){
        alert.show(
            <span ref={sessionRef}>
                Too many requests. Please try again later.
            </span>
            , {
                title: "Uh Oh..."
        });
    } else {
        console.info(data);
        auth.setCurrent(data.current);
        setFirstName(data.member.firstName);
        sessionStorage.setItem('isDigital', data.digital.valueBool);

        if(props.location.saveDetails){
          setSaveDetails(true);
          window.setTimeout(() => {
            setSaveDetails(false);
            props.location.saveDetails = false;
          }, 5000);
        }
        if(props.location.savePref){
          setSavePreferences(true);
          window.setTimeout(() => {
            setSavePreferences(false);
            props.location.savePref = false;
          }, 5000);
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    // Start of redirects
    const redirectRefer = () =>{
      redirectTo("referFriend");
    }

    const redirectPoints = () =>{
      redirectTo("points");
    }

     const redirectRenew = () =>{
       redirectTo("renew");
     }

     const redirectCard = () =>{
      redirectTo("card");
    }

    const redirectDetails = () =>{
      redirectTo("details");
    }

    const redirectSubscriptions = () =>{
      redirectTo("subscriptions");
    }

    const redirectDownloadApp = () =>{
      redirectTo("app");
    }

    function redirectTo(page){
      props.history.push("/"+page);
    }
    //End of redirects

    const logout = () =>{
      fetch(localStorage.getItem('server') + 'logout',{
        method: 'PUT',
        headers: {
          token: sessionStorage.getItem('token'),
          memberNumber: sessionStorage.getItem('memberNumber')
        }
      })
      .then(function(){
        document.cookie = "redirect=";
        document.cookie = "auth-token=";
        auth.logout(() =>{
          props.history.push("");
        });
      });
    }

    const sessionRef = (node)=>{
      if(node === null){
        window.location.replace(window.location.origin);
      }
    }

    const alert = useAlert();
    //Modal functions
    const openModal = ()=>{
      setShowModal(true);
    }

    const closeModal = ()=>{
      setShowModal(false);
    }

    return (
        <div className="container">
          <Prompt
            message={(location, action) => {
              if (action === 'POP') {
                return location.pathname === "/"
                ? `Do you wish to log out?`
                : true
              }
            }}
          />
          <div hidden={!savePreferences}>
            <Alert variant="success">
              <Alert.Heading className="text-center">Success!</Alert.Heading>
              <p className="text-center">Your preferences has been saved</p>
            </Alert>
          </div>
          <div hidden={!saveDetails}>
            <Alert variant="success">
              <Alert.Heading className="text-center">Success!</Alert.Heading>
              <p className="text-center">Your details has been updated</p>
            </Alert>
          </div>
          <div className="d-flex justify-content-center">
            <h1 id="gtm-home" className="home-heading-element">Hi {firstName}</h1>
            <Dropdown className="logout-dropdown">
              <Dropdown.Toggle variant="link" />
              <Dropdown.Menu>
                <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </div>
          <br/>
          <div className="row">
            <div className="homeBlock col-md-4 col-6" onClick={redirectDetails}>
              <img src={PersonalDetailsIcon} alt='Personal Details'/>
              <h5 className="homeText">Personal Details</h5>
            </div>
            <div className="homeBlock col-md-4 col-6" onClick={redirectSubscriptions}>
              <img src={PreferencesIcon} alt='Preferences' />
              <h5 className="homeText">Preferences</h5>
            </div>
            <div className="homeBlock col-md-4 col-6" onClick={redirectPoints}>
              <img src={RewardsIcon} alt='Rewards' />
              <h5 className="homeText">Rewards</h5>
            </div>
            <div className="homeBlock col-md-4 col-6" onClick={redirectRefer}>
              <img src={ReferIcon} alt="Refer" />
              <h5 className="homeText">Refer a Friend</h5>
            </div>
            <div className="homeBlock col-md-4 col-6" onClick={redirectDownloadApp}>
              <img src={AppIcon} alt="App" />
              <h5 className="homeText">Our App</h5>
            </div>

            <div className="homeBlock col-md-4 col-6" onClick={redirectCard}>
              <img src={CardIcon} alt="Card"/>
              <h5 className="homeText">Digital Card</h5>
            </div>
          </div>

          {/* Settings Modal */}
          <Modal size="lg" show={showModal} onHide={closeModal} centered >
            <Modal.Header className="modal-center">
              <button className="btn btn-outline-dark modal-logout point-cursor" onClick={logout}>Logout</button>
              <h1 className="modal-setting-heading">Settings</h1>
              <button className="btn btn-outline-dark modal-close-btn point-cursor" onClick={closeModal}>Close</button>
            </Modal.Header>
            <Modal.Body className="">
              <Container>
                <div className="modal-settings-children">
                  {modalSetting === 2 && <Setting2 />}
                </div>
              </Container>
            </Modal.Body>
          </Modal>

        </div>
      );
}